import { createFeatureSelector, createSelector } from "@ngrx/store";
import * as fromAcs from "./acs.reducer";

export const selectAcsState = createFeatureSelector<fromAcs.State>(
    fromAcs.acsFeatureKey,
);

export const selectAcsCredentials = createSelector(
    selectAcsState,
    (state: fromAcs.State) => state.credentials,
);
